"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormControlAttributes = exports.handleInputValueChange = exports.handleCheckedChange = void 0;
var handleCheckedChange = function (evt, updateChecked, onChangeCallback) {
    updateChecked(evt.target.checked);
    onChangeCallback && onChangeCallback(evt);
};
exports.handleCheckedChange = handleCheckedChange;
var handleInputValueChange = function (evt, updateValue, onChangeCallback) {
    updateValue(evt.target.value);
    onChangeCallback && onChangeCallback(evt);
};
exports.handleInputValueChange = handleInputValueChange;
var getFormControlAttributes = function (formControlProps, restrictedProps) {
    var attributes = {};
    formControlProps &&
        Object.keys(formControlProps)
            .filter(function (key) { return restrictedProps.indexOf(key) === -1; })
            .forEach(function (key) { return attributes[key] = formControlProps[key]; });
    return attributes;
};
exports.getFormControlAttributes = getFormControlAttributes;
